const legalSidebarLinks = [
  {
    group: 'Terms & Conditions',
    items: [
      { to: '/legal/terms-of-use', label: 'Terms of Use' },
      { to: '/legal/terms-and-conditions', label: 'Terms & Conditions' },
    ],
  },
  {
    group: 'Our Policies',
    items: [
      { to: '/legal/privacy-policy', label: 'Privacy Policy' },
      { to: '/legal/refund-policy', label: 'Refund Policy' },
      { to: '/legal/disclaimer', label: 'Disclaimer' },
      { to: '/legal/cookie-policy', label: 'Cookie Policy' },
    ],
  },
  {
    group: 'Compliance Rules',
    items: [
      { to: '/legal/kyc-policy', label: 'KYC Policy' },
      { to: '/legal/kyc-aml-policy', label: 'KYC AML Policy' },
      { to: '/legal/gdpr-compliance', label: 'GDPR Compliance' },
      { to: '/legal/global-compliance-policy', label: 'Global Compliance' },
      { to: '/legal/risk-disclaimer', label: 'Risk Disclaimer' },
    ],
  },
  {
    group: 'Service Provider',
    items: [
      { to: '/legal/service-provider-agreement', label: 'Service Provider Agreement' },
      { to: '/legal/tax-declaration-policy', label: 'Tax Declaration Policy' },
      { to: '/legal/commission-revenue-policy', label: 'Commission Revenue Policy' },
    ],
  },
  {
    group: 'Platform Safety',
    items: [
      { to: '/legal/trust-safety-policy', label: 'Trust & Safety Policy' },
      { to: '/legal/platform-integrity-policy', label: 'Platform Integrity Policy' },
      { to: '/legal/termination-policy', label: 'Termination Policy' },
      { to: '/legal/global-dispute-resolution-policy', label: 'Global Dispute Resolution' },
    ],
  },
  {
    group: 'Intellectual Property',
    items: [
      { to: '/legal/intellectual-property-rights', label: 'Intellectual Property Rights' },
      { to: '/legal/user-generated-content-policy', label: 'User Generated Content Policy' },
      { to: '/legal/dmca-policy', label: 'DMCA Policy' },
      { to: '/legal/content-usage-policy', label: 'Content Usage Policy' },
    ],
  },
  {
    group: 'Third Party & Marketing',
    items: [
      { to: '/legal/third-party-data-processors', label: 'Third Party Data Processors' },
      { to: '/legal/sponsored-content-policy', label: 'Sponsored Content Policy' },
      { to: '/legal/affiliate-marketing-policy', label: 'Affiliate Marketing Policy' },
    ],
  },
  {
    group: 'Verification',
    items: [
      { to: '/legal/verification', label: 'Verification Policy' },
      { to: '/legal/jurisdiction-age-policy', label: 'Jurisdiction Age Policy' },
    ],
  },
  {
    group: 'Community Rules',
    items: [
      { to: '/legal/advisor-conduct', label: 'Advisor Conduct' },
      { to: '/legal/code-of-conduct', label: 'Code of Conduct' },
      { to: '/legal/community-guidelines', label: 'Community Guidelines' },
      { to: '/legal/payout-policy', label: 'Payout Policy' },
    ],
  },
];

export default legalSidebarLinks;
